export default __webpack_public_path__ + "static/media/pay_alignment.516f944f.png";